import { memo } from 'react';
import { Col } from 'react-bootstrap';

type ErrorImageProps = {
  src: string;
  alt: string;
};

export const ErrorImage = memo(({ src, alt }: ErrorImageProps) => (
  <Col xl={4} lg={5} xs={8}>
    <div className="text-center mb-4">
      <img src={src} alt={alt} className="img-fluid error-image" style={{ maxWidth: '320px' }} />
    </div>
  </Col>
));
